export default __webpack_public_path__ + "static/media/gr.ee8135c6.svg";